import cx from 'classnames';
import React, { useState, useEffect } from 'react';
import { Button, Dropdown, DropdownButton } from "react-bootstrap";
import { IoHomeOutline } from 'react-icons/io5'
import { LuChevronsLeft, LuChevronsRight, LuComponent, LuTicket, LuUserCog } from 'react-icons/lu'
import { PiCertificate, PiUserFill } from 'react-icons/pi'
import { CiViewTable } from 'react-icons/ci'
import { FiAlignJustify } from 'react-icons/fi'
import { jwtDecode } from "jwt-decode";
import {  CiUser } from "react-icons/ci";
// Subscribe & Zoho subscribe - commented out
// import { MdPayment } from 'react-icons/md';
import Modal from "react-bootstrap/Modal";

// groupName
import {
  Navbar,
  Nav,
  NavItem,
 /* Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  InputGroup,*/
} from 'reactstrap';
import {  useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { fetchAllDataApi, getLatestMessages, getUnseenNotifications } from '../../services/notifications';
import { CiLogout } from "react-icons/ci";
import { FaBell, FaCalendarAlt, FaClock, FaRegBell, FaUser } from "react-icons/fa"; // For the Bell icon
import { seenNotification } from '../../services/notifications';
import PopoverNotification from './poppupNotification'; // Import the PopoverNotification component
import { LuBuilding2 } from 'react-icons/lu';
import { useTenant } from '../../context/TenantContext';

import './Header.css';
import i18n, { changeLanguage } from '../../i18n';
import { IoSearchOutline } from 'react-icons/io5';
import { FiSearch } from 'react-icons/fi';
import { getInfouserById, getUserInfo } from 'src/services/userServicer';
import { toast } from 'react-toastify';
import authService from '../../services/authService';


interface Notification {
  id: number;
  message: string;
  functionsAll: string;
  createdAt: Date;
  seen: boolean;
}

interface HeaderProps {
  onMobileToggle: () => void
  toggleSidebar?: () => void
  className?: string
}

type SimpleButtonProps = {
  variant?: string;
  onClick?: () => void;
  children?: React.ReactNode;
};

const SimpleButton = Button as React.ComponentType<SimpleButtonProps>;

const Header: React.FC<HeaderProps> = ({ onMobileToggle, toggleSidebar, className }) => {
  const { t } = useTranslation();
  const { currentTenant, isViewingAs, clearViewAs } = useTenant();
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  //const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState('en');
//  const [notifications, setNotifications] = useState([]);
 // const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const [isNotiOpen, setIsNotiOpen] = useState(false); // State to control notification popup visibility
  const [unseenCount, setUnseenCount] = useState(0); // Initial dummy data
  const [latestNotification, setlatestNotification] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isMobileSearchVisible, setIsMobileSearchVisible] = useState(false);
const [isLoading, setIsLoading] = useState(false);
    const [showProfile, setShowProfile] = useState(false);
  const [userData, setUserData] = useState<any>(null);
  
const handleProfileClick = async () => {
  try {
    setIsLoading(true);
    setShowProfile(true);

    const user = await getUserInfo();  
    console.log(user)// أولاً نحصل على بيانات المستخدم
    if (!user?.id) {
      toast.error("User not found");
      setShowProfile(false);
      return;
    }

    const data = await getInfouserById(user.id); // نستخدم الـ id هنا
    setUserData(data);
  } catch (error) {
    console.error("Failed to fetch user info:", error);
    toast.error("Failed to load user profile");
    setShowProfile(false);
  } finally {
    setIsLoading(false);
  }
};


  // Dummy data for all notifications
 /* const [allNotification, setAllNotification] = useState<Notification[]>([
    { id: 1, message: 'Notification 1', functionsAll: 'Message', createdAt: new Date(), seen: false },
    { id: 2, message: 'Notification 2', functionsAll: 'Reminder', createdAt: new Date(), seen: true },
    { id: 3, message: 'Notification 3', functionsAll: 'System', createdAt: new Date(), seen: false },
  ]);*/

const links = [
  { 
    page: 'dashboard', 
    labelKey: 'Sidebar.Home', 
    href: '/', 
    icon: (props: any) => <IoHomeOutline {...props} /> 
  },
  { 
    page: 'standards', 
    labelKey: 'Sidebar.Reference', 
    href: '/standards', 
    icon: (props: any) => <CiViewTable {...props} />
  },
  { 
    page: 'compliances', 
    labelKey: 'Sidebar.Compliance', 
    href: '/compliances', 
    icon: (props: any) => <LuComponent {...props} />
  },
  { 
    page: 'tickets', 
    labelKey: 'Sidebar.Tickets', 
    href: '/ticket', 
    icon: (props: any) => <LuTicket {...props} />
  },
  { 
    page: 'users', 
    labelKey: 'Sidebar.UserManagement', 
    href: '/user', 
    icon: (props: any) => <LuUserCog {...props} />
  },
  { 
    page: 'certifications', 
    labelKey: 'Sidebar.Certifications', 
    href: '/certifications', 
    icon: (props: any) => <PiCertificate {...props} />
  },
];

  // Function to mark notifications as seen
  const seeNotification = async () => {
    try {
      const user = await getUserInfo();
      if (!user?.id) return;
      let userId =  user.id || "";
      await seenNotification(userId);
      setUnseenCount(0);
      setIsNotiOpen(false); // Close the notification popup
    } catch (error) {
      console.error("Error marking notifications as seen:", error);
    }
  };

  // Toggle language dropdown
  const toggleLanguageDropdown = () => {
    setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
  };
  const toggleMobileSearch = () => {
    setIsMobileSearchVisible(!isMobileSearchVisible);
  };
  // Handle logout - same as landing and v2-frontend
  const handleLogout = async () => {
    try {
      // Set logout flag
      (window as any).__LOGGING_OUT__ = true;
      
      // Use logoutService which calls /auth/force-logout (same as landing and v2-frontend)
      const logoutService = (await import('../../services/logoutService')).default;
      const result = await logoutService.logout();
      
      // Reset logout flag
      (window as any).__LOGGING_OUT__ = false;
      
      // Show toast message and redirect (same as landing and v2-frontend)
      if (result.success) {
        toast("user logged out successfully", { type: "success" });
      } else {
        toast("you logged out but session is still active connect with admin", { type: "error" });
      }
      
      // Redirect to login with full path
      window.location.href = '/login';
    } catch (error: any) {
      console.error('Logout error:', error);
      
      // Even if logout fails, clear everything (same as landing and v2-frontend)
      localStorage.clear();
      const { clearV2Token } = await import('../../utils/v2AuthUtils');
      const domain = process.env.REACT_APP_DOMAIN || window.location.hostname;
      clearV2Token(domain);
      
      const SecureCookieManager = (await import('../../utils/secureCookie')).default;
      SecureCookieManager.clearAuthCookies();
      
      (window as any).__LOGGING_OUT__ = false;
      toast("you logged out but session is still active connect with admin", { type: "error" });
      window.location.href = '/login';
    }
  };

  // Fetch notifications (dummy implementation)
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const user = await getUserInfo();
        if (!user?.id) return;
        let userId =  user.id || "";
        const total_count = await fetchAllDataApi(`notifications/unseen?userId=${userId}&query=${""}&perPage=${5}&pageNo=${0}`);
        const latestMessages = await getLatestMessages(`notifications/notifications-latest`);
        setlatestNotification(latestMessages?.data)
       // setTotalCount(total_count?.totalCount);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchNotifications();
    getUnseenNotificationsData()
  }, []);

  const getUnseenNotificationsData = async () => {
    try {
      const user = await getUserInfo();
      if (!user?.id) return;
      const userId = user.id || "";
      const unseenNotifications = await getUnseenNotifications(userId);
      if (unseenNotifications?.success) {
        setUnseenCount(unseenNotifications.totalCount ?? 0);
      } else {
        setUnseenCount(0);
      }
    } catch (e) {
      console.warn("Unseen notifications unavailable (offline or API error):", e);
      setUnseenCount(0);
    }
  };

  /*useEffect(() => {
    const socket = getWebSocket();

    if (socket) {
      socket.on('receiveNotification', (notification:any) => {
        // Option 1: Increment the unseen count
       // console.log('notification', notification)
        setUnseenCount((prevCount) => prevCount + 1);
        getUnseenNotificationsData()
        // Option 2: Fetch notifications again
        // fetchNotifications();
      });
    }

    return () => {
      if (socket) {
        socket.off('receiveNotification'); // Clean up the event listener
      }
    };
  }, []);*/

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'en' ? 'ar' : 'en';
    // Use the changeLanguage function from i18n which includes sync functionality
    changeLanguage(newLanguage);
    setCurrentLanguage(newLanguage);
  };

  return (
    <Navbar className="root-header">
      {/* Sidebar toggle button (Visible only on md and up) */}
      <button
        type="button"
        className="sidebar-toggle d-none d-md-flex"
        onClick={onMobileToggle}
        aria-label={isSidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
        aria-expanded={isSidebarOpen}
      >
        {isSidebarOpen ? (
          <LuChevronsLeft size={18} strokeWidth={2.25} aria-hidden />
        ) : (
          <LuChevronsRight size={18} strokeWidth={2.25} aria-hidden />
        )}
      </button>

      {/* Per-tenant brand — logo + display name. Renders the current effective
          tenant (reflects view-as). Falls back to a building icon when no logo
          is uploaded yet. Display name follows the active UI language. */}
      {currentTenant && (
        <div className="header-tenant-brand" title={currentTenant.name}>
          {currentTenant.logoUrl ? (
            <img
              src={`${process.env.REACT_APP_API_URL || ''}${currentTenant.logoUrl}`}
              alt=""
              className="header-tenant-brand__logo"
            />
          ) : (
            <LuBuilding2
              size={18}
              className="header-tenant-brand__icon"
              aria-hidden
            />
          )}
          <span className="header-tenant-brand__name d-none d-md-inline">
            {currentLanguage === 'ar'
              ? (currentTenant.nameAr || currentTenant.name)
              : currentTenant.name}
          </span>
          {isViewingAs && (
            <button
              type="button"
              onClick={clearViewAs}
              title="Stop viewing as this organization and return to your own"
              style={{
                marginInlineStart: 6,
                background: '#fef3c7',
                color: '#92400e',
                border: '1px solid #fcd34d',
                borderRadius: 999,
                padding: '2px 8px',
                fontSize: 11,
                fontWeight: 600,
                cursor: 'pointer',
                textTransform: 'uppercase',
                letterSpacing: 0.3,
              }}
            >
              view-as · exit ×
            </button>
          )}
        </div>
      )}

      {/* Mobile navigation dropdown without toggle button */}
      <div className="d-flex d-md-none align-items-center">
        <Dropdown>
          <Dropdown.Toggle 
            variant="link" 
            id="mobile-nav-dropdown"
            className="mobile-menu-button"
          >
            <span className="navbar-toggler-icon"></span>
          </Dropdown.Toggle>
  
          <Dropdown.Menu className="mobile-nav-menu">
            {links.map((link) => (
              <Dropdown.Item 
                key={link.href}
                onClick={() => {
                  navigate(link.href);
                  setIsMobileNavOpen(false);
                }}
                className="mobile-nav-item"
              >
                <div className="d-flex align-items-center">
                  {React.createElement(link.icon, { className: "me-2" })} {t(link.labelKey)}
                </div>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
  
      {/* Search bar */}
      <div className={`search-container ${isMobileSearchVisible ? 'mobile-visible' : ''}`}>
        <Nav className="w-100">
          <NavItem className="w-100">
            <div className="inputSearch">
              <input
                type="text"
                placeholder={t('header.Search ....') || ''}
                className="form-control w-100 border-0 shadow-none"
                autoComplete="off"
              />
            </div>
          </NavItem>
        </Nav>
      </div>
  
      {/* Mobile search toggle button */}
      <button
        type="button"
        className="header-chrome-btn mobile-search-toggle d-md-none"
        onClick={toggleMobileSearch}
        aria-label={t('header.Search ....') || 'Search'}
      >
        <FiSearch size={17} className="header-chrome-btn__icon" aria-hidden />
      </button>
  
      {/* Right side elements */}
      <div className="header-right-elements">
        {/* Notification */}
        <div className="notification-wrapper">
          <button
            type="button"
            className="header-chrome-btn header-chrome-btn--notifications"
            onClick={() => setIsNotiOpen((s) => !s)}
            aria-label="Notifications"
            aria-expanded={isNotiOpen}
          >
            <FaRegBell size={17} className="header-chrome-btn__icon" aria-hidden />
            {unseenCount > 0 && (
              <span className="notification-badge">{unseenCount}</span>
            )}
          </button>
          <PopoverNotification
            isOpen={isNotiOpen}
            onClose={() => setIsNotiOpen(false)}
            updateNotifications={seeNotification}
            notifications={latestNotification}
          />
        </div>
  
        {/* Language selector */}
        <button
          type="button"
          className="header-chrome-btn header-chrome-btn--lang lang-switch d-flex align-items-center"
          onClick={toggleLanguage}
          aria-label={currentLanguage === 'en' ? 'Switch to Arabic' : 'Switch to English'}
        >
          <div className="language-flag">
            <img
              src={`/assets/images/${currentLanguage}.jpg`}
              alt={currentLanguage}
            />
          </div>
          <span className="d-none px-2 d-sm-inline">
            {currentLanguage === 'en' ? t('header.english') : t('header.arabic')}
          </span>
        </button>
  
        {/* Divider */}
        <div className="header-divider"></div>
  
        {/* Profile dropdown */}
        <Dropdown align="end" className="profile-dropdown">
        <Dropdown.Toggle as="div" className="profile-toggle header-chrome-btn header-chrome-btn--profile">
            <div className="admin-photo">
              <PiUserFill size={18} className="admin-photo__icon" aria-hidden />
            </div>
          </Dropdown.Toggle>
          
      <Dropdown.Menu className="profile-dropdown-menu">
        <Dropdown.Item onClick={handleProfileClick} className="logout-item">
          <CiUser className="logout-icon" />
          <span>My Profile</span>
        </Dropdown.Item>

        {/* Subscribe & Zoho subscribe - commented out
        <Dropdown.Item onClick={() => navigate('/subscription')} className="logout-item">
          <MdPayment className="logout-icon" />
          <span>{t("header.Subscription")}</span>
        </Dropdown.Item>
        */}

        <Dropdown.Divider />

        <Dropdown.Item onClick={handleLogout} className="logout-item">
          <CiLogout className="logout-icon" />
          <span>Logout</span>
        </Dropdown.Item>
      </Dropdown.Menu>

        <Modal show={showProfile} onHide={() => setShowProfile(false)} centered dialogClassName="modal">
  <Modal.Header closeButton className="bg-light" dir={currentLanguage === 'ar' ? 'rtl' : 'ltr'}>
    <Modal.Title className="w-100 text-center">
      <FaUser className="text-primary mb-2" size={64} />
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {isLoading ? (
      <div className="text-center py-4">
        <span className="spinner-border text-primary" role="status"></span>
        <p className="mt-2">{t("header.Loading")}...</p>
      </div>
    ) : userData ? (
      <div className="text-center">
        {/* Name */}
        <h4 className="fw-bold">{userData.name}</h4>
        <p className="text-muted">{userData.email}</p>

        {/* Group badge */}
        <span className="badge bg-warning text-dark px-3 py-2 mb-4 rounded-pill">
          {userData.group?.name || t("header.Group")}
        </span>

        {/* User Info */}
        <div className="text-start px-4">
          <div className="mb-3 d-flex align-items-center">
            <FaUser className="me-2 text-secondary" />
            <strong className="me-2">{t("header.Username")}:</strong> {userData.username}
          </div>
          <div className="mb-3 d-flex align-items-center">
            <FaClock className="me-2 text-secondary" />
            <strong className="me-2">{t("header.Last Login")}:</strong> {userData.lastLogin || ""}
          </div>
          <div className="mb-3 d-flex align-items-center">
            <FaCalendarAlt className="me-2 text-secondary" />
            <strong className="me-2">{t("header.Created At")}:</strong> {new Date(userData.createdAt).toLocaleDateString()}
          </div>
        </div>
      </div>
    ) : (
      <div className="text-danger text-center">
        <p>{t("header.Failed to load profile data")}</p>
      </div>
    )}
  </Modal.Body>

  <Modal.Footer>
    <SimpleButton variant="secondary" onClick={() => setShowProfile(false)}>
      {t("header.Close")}
    </SimpleButton>
  </Modal.Footer>
</Modal>

        </Dropdown>
      </div>
    </Navbar>
  );
  
}

export default Header;